export default "__VITE_ASSET__9g2PiHyM__"